var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("actions"),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col-md-2" }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                gap: "10px",
                "align-items": "center",
              },
            },
            [
              _vm._v("\n        Mostrar\n        "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.perPage,
                      expression: "perPage",
                    },
                  ],
                  staticClass: "form-control",
                  staticStyle: { "min-width": "75px" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.perPage = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.perPageOptions, function (optionValue) {
                  return _c("option", { key: optionValue }, [
                    _vm._v(_vm._s(optionValue)),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-lg-inline" }, [
                _vm._v("Registros"),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-10" }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "align-items": "flex-end",
                gap: "5px",
              },
            },
            [
              _vm.isVisibleSearch
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "5px",
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchQuery,
                            expression: "searchQuery",
                          },
                        ],
                        staticClass: "form-control",
                        staticStyle: {
                          display: "inline-block",
                          "max-width": "200px",
                        },
                        attrs: { type: "text", placeholder: "Buscar" },
                        domProps: { value: _vm.searchQuery },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.searchQuery = $event.target.value
                            },
                            _vm.handleInput,
                          ],
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isVisibleCSVButton
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-default buttons-pdf buttons-html5",
                      staticStyle: { margin: "0" },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("csvClick")
                        },
                      },
                    },
                    [_vm._v("\n          CSV\n        ")]
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }